import { render, staticRenderFns } from "./PaymentSettlementButton.vue?vue&type=template&id=0740a8a7&scoped=true&"
import script from "./PaymentSettlementButton.vue?vue&type=script&lang=js&"
export * from "./PaymentSettlementButton.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettlementButton.vue?vue&type=style&index=0&id=0740a8a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740a8a7",
  null
  
)

export default component.exports